<template>
	<div>
		<div class="home-title">
			<div class="logo">
				<img src="../../assets/img/logo1.png" alt="">
			</div>
			<nav>
				<div @click="routerChange(1)">首页</div>
				<div @click="routerChange(2)">产品矩阵</div>
				<div @click="routerChange(3)">案例介绍</div>
				<div class="active">关于我们</div>
			</nav>
		</div>
		<div class="banner">
			<!-- <div class="banner-text">
				<div>连接一切可能</div>
				<div>欢迎来到中恒玖联 给与您的帮助,是我们最大的荣幸</div>
			</div> -->
			<img src="../../assets/img/about-banner.png" alt="" class="banner-bg">
		</div>
		<div class="overview-list">
			<div class="overview-li">
				<div :class="idx==1?'active':''" @click="change(1)">公司概况</div>
				<div :class="idx==2?'active':''" @click="change(2)">企业文化</div>
			</div>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default({
		data(){
			return{
				idx:1,
			}
		},
		methods:{
			change(i){
				this.idx=i
				if(i==1){
					this.$router.push('/about/overview_p')
				}else{
					this.$router.push('/about/enterprise_p')
				}
			},
			routerChange(i){
				this.$router.push({
					path:'/',
					query:{
						i
					}
				})
			}
		}
	})
</script>

<style lang="scss" scoped>
	.home-title{
		height:3.2rem;
		box-sizing: border-box;
		display:flex;
		justify-content: space-between;
		align-items: center;
		background:#fff;
		padding:0 1.2rem;
		position: fixed;
		top:0;
		left:0;
		width:100%;
		z-index: 10;
		box-sizing: border-box;
		.logo{
			>img{
				width:3.98rem;
				height:1.2rem;
			}
		}
		nav{
			display:flex;
			align-items: center;
			color:#000;
			font-size: 0.8rem;
			padding:.8rem 0;
			:last-child{
				margin-right:0;
			}
			>a{
				padding:.2rem 0;
				margin-right:3.95rem;
				color:#000;
				line-height: 1.2rem;
				&.active{
					border-bottom:1px solid #000;
				}
			}
			>div{
				line-height: 1.2rem;
				cursor: pointer;
				margin-right:3.95rem;
				&.active{
					border-bottom:1px solid #000;
				}
			}
		}
	}
	.banner{
		width:100%;
		height:15rem;
		position: relative;
		margin-top:3.2rem;
		.banner-bg{
			position: absolute;
			left:0;
			top:0;
			width:100%;
			height:100%;
		}
		.banner-text{
			position: relative;
			z-index: 5;
			color:#fff;
			height:100%;
			display:flex;
			flex-direction: column;
			justify-content: center;
			>div:nth-child(1){
				font-size: 2.4rem;
				line-height: 2.81rem;
				font-weight: 900;
			}
			>div:nth-child(2){
				font-size:.8rem;
				line-height: 1.2rem;
				margin-top:.6rem;
			}
		}
			
	}
	.overview-list{
		.overview-li{
			display:flex;
			justify-content: center;
			background:#fff;
			>div{
				padding:.75rem 0;
				font-size: 0.8rem;
				color: #000000;
				line-height: 0.94rem;
				cursor: pointer;
				&:nth-child(2){
					margin-left:2.4rem;
				}
				&.active{
					border-bottom:0.05rem solid #1790FF;
				}
			}
		}
	}
</style>